<template>
  <div id="overlay-wrapper">
    <transition name="slide-fade-TO-BOT">
      <div class="header-section" v-if="animatedPage">
        <div class="page-title kaushan-font">{{ component.title }}</div>
        <close-icon class="close-icon" @closeIconClicked="closeOverlay" />
      </div>
    </transition>
    <transition name="slide-fade-TO-TOP">
      <div class="content-section" v-if="animatedPage">
        <!-- <perfect-scrollbar ref="scroll"> -->
        <div class="content-wrapper custom-scrollbar">
          <component
            :is="component.bind.is"
            v-bind="component.bind"
            v-on="component.on"
          ></component>
        </div>
        <!-- </perfect-scrollbar> -->
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "Overlay",
  props: {
    component: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      animatedPage: false
    };
  },
  created() {
    this.animatedPage = false;
    window.addEventListener("keyup", this.handleKeyup);
  },
  mounted() {
    this.animatedPage = true;
  },
  beforeDestroy() {
    window.removeEventListener("keyup", this.handleKeyup);
  },
  methods: {
    handleKeyup(event) {
      if (event.key === "Escape") {
        this.closeOverlay();
      }
    },
    closeOverlay() {
      this.animatedPage = false;
      setTimeout(() => {
        this.$eventBus.closeOverlay();
      }, 600);
    }
  }
};
</script>
<style lang="scss" scoped>
@import "~@/styles/variables.scss";
#overlay-wrapper {
  width: 100vw !important;
  height: 100% !important;
  position: fixed;
  top: 0;
  left: 0;
  background-color: transparent;
  z-index: $Z-overlay;
  .header-section {
    height: 50px;
    width: 100%;
    border-bottom: 2px solid $color-primary;
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    .page-title {
      font-size: 20px;
      margin-left: 20px;
    }
    .close-icon {
      position: absolute;
      right: 20px;
    }
  }
  .content-section {
    border-top: 2px solid $color-primary;
    background-color: #fff;
    height: calc(100% - 50px);
    width: 100%;
  }
}
.content-wrapper {
  max-height: 100%;
  height: 100%;
  width: 100%;
}
</style>
